const BUTTONS = 'buttons'; // buttons column
const DEFAULT = 'default'; // simple text

export default {
  BUTTONS,
  DEFAULT,
};



// WEBPACK FOOTER //
// ./src/components/cms/grid/columnTypes.js